import PropTypes from 'prop-types';
import React from 'react';

import BaseModal from '../../general/BaseModal';
import t from "../../../lib/I18n";
import TrackingActions from "../../../actions/TrackingActions";
import { GenericModals } from "../../../constants/AppConstants";

class SmartcardInfoModal extends React.PureComponent {

    static propTypes = {
        onClose: PropTypes.func.isRequired
    };

    render () {

        const modalProps = {
            onClose: this.props.onClose,
            titleText: t('booking.smartcard.info.header'),
            className: 'modal--sm',
            hideContinue: true,
            onOpen: () => TrackingActions.genericModalOpen(GenericModals.SMARTCARD_TUTORIAL)
        };

        return (
            <BaseModal { ...modalProps }>
                <div className="margin-bottom--sm">
                    { t('booking.smartcard.info.body') }
                </div>
            </BaseModal>
        );
    }

}


export default SmartcardInfoModal;



// WEBPACK FOOTER //
// ./src/components/search/smartcard/SmarcardInfoModal.js